import React from 'react';

/**
 * Capture function supplied by the OET (a descendant) and consumed by
 * ProjectActions. It triggers an image capture of the OET and resolves with the
 * captured payload. The payload is opaque at this layer (it flows straight into
 * the export pipeline), so it is left `unknown`.
 *
 * The historical default returns `void` (its body discards the rejected
 * promise), so the return type is `void | Promise<unknown>`.
 */
export type CaptureOET = () => void | Promise<unknown>;

/** The value carried by {@link ImageContext}. */
export interface ImageContextValue {
  captureOET: CaptureOET;
  setCaptureOET: (fn: CaptureOET) => void;
}

// A React Context to support the export of images. The OET component adds its
// function for exporting an image to this context. We can then inject it in the
// ExportImageModal component.
export default React.createContext<ImageContextValue>({
  captureOET: () => {
    Promise.reject();
  },
  setCaptureOET: () => {},
});
